export default "__VITE_ASSET__18897b4d__"